export default __webpack_public_path__ + "static/media/html.aff8a9cb.svg";